<template>
    <!-- 这里只是一个很薄的容器，/video指向这里、/:id指向内嵌的router-view，并令内页使用一个key来不复用 -->
	<router-view :key="$route.fullPath"></router-view>
</template>

<script>

export default {
	name: "VlogDetail",
};
</script>
<style scoped>
</style>
